
<div class="item-count">
    {{ count }}
</div>
